/**
 * 停车记录
 */
import React from "react";

import { Input, Row, Col, Icon, Tooltip, Select, Switch } from "antd";
import http from "../../axios/http";
import PageLayout from "../ui/PageLayout";
import messager from "../ui/messager";
import server from "../../axios/server";
import { global_data } from '../ui/auth'

class VehicleParkInfo extends React.Component {
  columns = [
    {
      title: "ID",
      dataIndex: "id",
      width: "10%",
    },
    {
      title: "场地",
      dataIndex: "zone",
      width: "10%",
      render: (text, record, index) => {
        var zoneName = "";
        this.state.parkZones.forEach((row) => {
          if (row.code === text) {
            zoneName = row.name;
          }
        });
        return zoneName;
      },
    },
    {
      title: "车牌号",
      dataIndex: "plateNo",
      width: "10%",
    },
    {
      title: "车架号",
      dataIndex: "vin",
      width: "10%",
    },
    {
      title: "入场时间",
      dataIndex: "inTime",
      width: "15%",
    },
    {
      title: "入场道闸",
      dataIndex: "inGateName",
      width: "10%",
    },
    {
      title: "出场时间",
      dataIndex: "outTime",
      width: "15%",
    },
    {
      title: "出场道闸",
      dataIndex: "outGateName",
      width: "10%",
    },
    {
      title: "停车费",
      dataIndex: "parkFee",
      width: "10%",
    },
    {
      title: "状态",
      dataIndex: "stateStr",
      width: "10%",
      render: (text, record, index) => (
        <div>
          <div>{this.getStateDisplay(record)}</div>
        </div>
      ),
    },
  ];

  getStateDisplay = (record) => {
    if (record.state === 200) {
      return this.getStateStr(record.state);
    } else {
      return (
        global_data.authCode.includes("RELEASE_PARK_INFO")?
        <Tooltip title="手工离场">
          {this.getStateStr(record.state)}
          <Icon
            type="stop"
            theme="filled"
            className="table-operate-icon"
            onClick={this.realeaseInfo.bind(this, record)}
          />
        </Tooltip>
        :this.getStateStr(record.state)
      );
    }
  };

  getStateStr = (state) => {
    switch (state) {
      case 200:
        return "已离场";
      case 800:
        return "待付费";
      case 1:
        return "在场内";
      default:
        return "其他";
    }
  };

  realeaseInfo = (info, e) => {
    messager.confirm("是否清理该待付费停车记录？", () => {
      http.post({
        url: "/barrier/vehicleParkInfo/releaseParkInfo",
        data: { id: info.id },
        success: (res) => {
          http.post({
            url:
              server.mallServerUrl + "/externalApi/barrier/updateParkInfoCache",
            data: { id: info.id },
            success: (res) => {
              console.log("mallapi停车缓存刷新成功");
            },
          });
          let queryData = this.state.queryData;
          this.state.loadData(queryData);
          messager.notify("处理成功！");
        },
      });
    });
  };

  state = {
    loadData: "",
    queryData: { type: "" },
    parkZones: [],
  };

  loadAllZone = () => {
    http.post({
      url: "/barrier/parkZone/allZone",
      data: {},
      success: (res) => {
        this.setState({ parkZones: res });
      },
    });
  };
  componentWillMount() {
    this.loadAllZone();
  }

  typeChange = (val) => {
    console.log("typeChange", val);
    let queryData = this.state.queryData;
    queryData["type"] = val;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  keywordSearch = (value) => {
    console.log("keywordSearch", value);
    let queryData = this.state.queryData;
    queryData["keyword"] = value;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  stayChange = (val) => {
    console.log("stayChange", val);
    let queryData = this.state.queryData;
    if (val) queryData["stay"] = 1;
    else delete queryData["stay"];
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  hisChange = (val) => {
    console.log("hisChange", val);
    let queryData = this.state.queryData;
    if (val) queryData["his"] = 1;
    else delete queryData["his"];
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  render() {
    var { parkZones, queryData } = this.state;
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PageLayout
          condition={
            <Row>
              <Col span={24}>
                <Input.Search
                  placeholder="车架号或车牌号"
                  onSearch={this.keywordSearch}
                  style={{ width: "200px" }}
                  enterButton
                />
                &nbsp;
                <Select
                  value={queryData.type}
                  onChange={this.typeChange}
                  style={{ width: "100px" }}
                >
                  <Select.Option value="">全部</Select.Option>
                  {parkZones &&
                    parkZones.map((item, index) => (
                      <Select.Option key={item.id} value={item.code}>
                        {item.name}
                      </Select.Option>
                    ))}
                </Select>
                &nbsp; 只显示场内(在场+今日离场数据){" "}
                <Switch onChange={this.stayChange} value={queryData.stay} />
                &nbsp; 查询往日已离场数据{" "}
                <Switch onChange={this.hisChange} value={queryData.his} />
              </Col>
            </Row>
          }
          rowKey="id"
          url="/barrier/vehicleParkInfo/query"
          columns={this.columns}
          loadData={(func) => {
            this.setState({ loadData: func });
          }}
        />
      </div>
    );
  }
}

export default VehicleParkInfo;
